/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  accessLevel: "Access Level",
  active: "Active",
  ACTIVE: "Active",
  add: "Add",
  addANewUser: "Add a new user",
  addNewUser: "Add new user",
  areYouSureYouWantToDeactivateSca:
    "Are you sure you want to deactivate strong customer authentication for this user? Re-enabling will require user to setup SCA again.",
  areYouSureYouWantToDemoteUserFromOwner:
    "Are you sure you want to demote this user to standard user? He/she will loose all permissions.",
  areYouSureYouWantToSendResetPasswordEmailToUser:
    "Are you sure you want to send reset password email to {{user}}?",
  backToAllUsers: "Back to all users",
  checkedPermissions: "{{checked}} / {{total}} permissions",
  configuration: "Configuration",
  couldNotRemoveSca:
    "Could not remove strong customer authentication. Please try again later.",
  couldNotResetThePassword:
    "Could not reset the password. Please try again later.",
  customer: "Customer",
  customers: "Customers",
  deactivateUser: "Deactivate User",
  demoteFromOwner: "Demote to standard user",
  edit: "Edit",
  editUser: "Edit user",
  email: "Email",
  "Email address": "Email address",
  emailNotCompliantWithRFC5322:
    "E-mail not compliant with RFC 5322 format. It should contain a valid local part (1-64 characters), '@' symbol, and domain (1-255 characters).",
  fuzeboxAccess: "Fuzebox Access",
  generalInformation: "General information",
  givenUsercouldNotBeFound:
    "Given user could not be found. Make sure you are on correct mode (production/sandbox).",
  inactive: "Inactive",
  INACTIVE: "Inactive",
  isThisAVoltAdminAccount: "Volt Admin",
  iUnderstand: "I understand",
  lastSuccessfulLogin: "Last Login to Fuzebox",
  locked: "Locked",
  Name: "Name",
  neverLoggedIn: "User never logged in",
  newUser: "New user",
  onlyTopLevelCustomerAreAvailableForOwners:
    "Owners can be assigned only to top-level customers.",
  owner: "Owner",
  OWNER: "Owner",
  ownerType: "Owner",
  ownerUser: "Owner user",
  ownerUserHasAccessToAllFuzeboxFeatures:
    "Owner user will have complete and unrestricted access to all settings and data.",
  pageDescription: `Users who can access the Volt merchant portal from your organisation.
Admin users can add other users, configure applications and make changes to your merchant account.
Standard users can view your transactions and invoices.`,
  Password: "Password",
  "Password confirmation": "Password confirmation",
  passwordHasBeenSuccessfullyReset:
    "Password reset link has been sent to this user.",
  permissions: "Permissions",
  Permissions: "Permissions",
  permissionsAmount: "{{count}} permission",
  permissionsAmount_plural: "{{count}} permissions",
  permissionsPreviewEmptyList: "No permissions assigned for this user.",
  permissionsPreviewIsOwner:
    "Owner user has complete and unrestricted access to all settings and data.",
  permissionsPreviewSectionDescription:
    "This is the overview of permissions {{name}} has on Fuzebox",
  pleaseOnlySelectForVoltEmployees: "Please only select for Volt employees",
  promoteToOwner: "Promote to owner",
  reactivateUser: "Reactivate User",
  removeSca: "Remove SCA",
  removeStrongCustomerAuthentication: "Remove strong customer authentication",
  resetPassword: "Reset Password",
  roles: "roles",
  saveChanges: "Save changes",
  sca: "SCA",
  scaHasBeenSuccessfullyRemovedForThisUser:
    "Strong customer authentication has been successfully removed for this user.",
  scaIsEnabled: "SCA is enabled",
  scaIsNotEnabled: "SCA is not enabled",
  security: "Security",
  selectCustomerHierarchyPrompt:
    "Select customer hierarchy that the user will be able to access on our platform. Volt user cannot be assigned to a customer.",
  standard_user: "Standard user",
  standardUser: "Standard user",
  status: "Status",
  strongCustomerAuthentication: "Strong Customer Authentication",
  theUserCouldNotBePromotedToOwner: "The user could not be promoted to owner.",
  theUserHasBeenCreated:
    "The user has been created. An e-mail verification link has been sent to {{email}} to finish the set-up.",
  theUserHasBeenModified: "The user has been modified.",
  theUserHasBeenPromotedToOwner:
    "The user has been successfully promoted to owner.",
  thisIsWhereYouCanManageAndAdjustThePermissions:
    "This is where you can manage and adjust the permissions.",
  thisUserCannotBePromotedToOwner: `This user cannot be promoted to owner because it is currently
    assigned to customer <Link>{{name}}</Link>
    which is not at the top of the hierarchy. Before promoting, this
    user must be moved to the top-level customer in the hierarchy.`,
  thisUserIsLockedDueToIncorrectLoginAttempts:
    "This user is locked due to incorrect login attempts",
  thisUserWillBePromotedToAnOwnerUser: `This user will be promoted to an owner user type in the
    hierarchy of <Link>{{name}}</Link>. It means he/she will have access to all Fuzebox features as
    well as creating and managing other owner users.`,
  toChangeTheHierarchyFirstDemoteOwner:
    "To change the hierarchy, you must first demote the owner to standard user.",
  topLevelRoleInOrganisation: "Top-level role in organisation",
  twoFaAuthenticatorCannotBeDisabledForVoltAdmins:
    "Two factor authentication cannot be disabled for Volt Admins",
  twoFactorAuthenticator: "Two-factor authentication",
  twoFaHasBeenSuccessfullyRemovedForThisUser:
    "Two-factor authentication has been successfully removed for this user.",
  twoFaIsEnabled: "Two-factor authentication is enabled",
  twoFaIsNotEnabled: "Two-factor authentication is disabled",
  user: "User",
  userCouldNotBeDemotedToStandardUser: "There was a problem demoting the user.",
  userDetails: "User details",
  useResetPasswordButtonBelow: 'Use "Reset Password" button below',
  userHadBeenDemotedToStandardUser:
    "The user has been demoted to standard user.",
  userHasAccessToAllCustomers:
    "The user has access to all Volt customer accounts",
  userHasAccessToCustomersWithinHierarchy:
    "The user has access to all customer accounts within the hierarchy",
  userNotFound: "User not found",
  users: "Users",
  userType: "Type",
  userTypeOwnerTooltip:
    "Owner has all management and view permissions and is responsible for administration in the hierarchy.",
  userWontBeAbleToUseFuzebox: "{{user}} won't be able to use Fuzebox.",
  volt_admin: "Volt admin",
  VOLT_ADMIN: "Volt admin",
  voltAdminAccess: "Volt Admin Access",
  voltAdminUser: "Volt admin",
  youCannotEditOwnerUser: "Only owners can edit other owner users",
  youCannotEditYourself: "You cannot edit yourself",
  youDontHaveAnyUsersSetUpRightNowDoTalkToYourSystemAdministrator:
    "You don't have any users set up right now, do talk to your system administrator if you think there's an issue or our support team",
  youDontHaveAnyUsersSetUpRightNowLetsGetStarted:
    "You don't have any users set up right now, let's get started",
  youDontHaveEnoughPermissionsToEditThisUser:
    "You don't have enough permissions to edit this user",
};
